import { PostMessage } from "../../services/PostMessage/PostMessage";

export class EventEmitterAdapter {
    constructor(EventEmitter = new PostMessage()) {
        this.EventEmitter = EventEmitter;
    }

    async exec(params) {
        return await this.EventEmitter.exec(params);
    }
}
